var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import SafeEventEmitter from "@metamask/safe-event-emitter";
import { log } from "..";
import { checkChainId, defaultChainConfigs, } from "../config";
import { SUPPORTED_ADAPTERS } from "../wallet";
export const ADAPTER_STATUS = {
    NOT_READY: "not_ready",
    READY: "ready",
    CONNECTING: "connecting",
    CONNECTED: "connected",
    DISCONNECTED: "disconnected",
    ERRORED: "errored",
};
export const ADAPTER_EVENTS = Object.assign(Object.assign({}, ADAPTER_STATUS), { CHAIN_CHANGED: "chain_changed", ACCOUNT_CHANGED: "account_changed", CACHE_CLEAR: "cache_clear" });
export class BaseAdapter extends SafeEventEmitter {
    constructor(options = { chainId: "0x1" }) {
        super();
        // should be added in constructor or from setAdapterSettings function
        // before calling init function.
        this.currentChainConfigId = null;
        this.web3AccessTokenServer = "https://main.protico.io";
        this.knownChainConfigs = {};
        this.initChainConfig();
        this.setAdapterSettings(options);
    }
    get chainConfigProxy() {
        return this.knownChainConfigs[this.currentChainConfigId]
            ? Object.assign({}, this.knownChainConfigs[this.currentChainConfigId]) : null;
    }
    init(options) {
        return __awaiter(this, void 0, void 0, function* () {
            this.checkInitializationRequirements();
            return this._init(options);
        });
    }
    connect() {
        return __awaiter(this, void 0, void 0, function* () {
            this.checkConnectionRequirements();
            return this._connect();
        });
    }
    disconnect() {
        return __awaiter(this, void 0, void 0, function* () {
            this.checkDisconnectionRequirements();
            return this._disconnect();
        });
    }
    switchChain(chainId) {
        return __awaiter(this, void 0, void 0, function* () {
            this.checkSwitchChainRequirements(chainId);
            return this._switchChain(chainId);
        });
    }
    ensureConnectedAndGetAccount() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.web3AccessTokenServer)
                throw Error("web3AccessTokenServer is not configured");
            if (!this.provider || this.status !== ADAPTER_STATUS.CONNECTED)
                throw Error("Not connected with wallet.");
            const accounts = (yield this.provider.request({
                method: "eth_accounts",
            }));
            if (!accounts || accounts.length === 0)
                throw Error("Not connected with wallet");
            return accounts[0];
        });
    }
    setAdapterSettings(options) {
        const chainId = options.chainId;
        if (chainId) {
            if (!checkChainId(chainId)) {
                throw Error("Invalid chainId");
            }
            this.currentChainConfigId = chainId;
        }
        if (options.web3AccessTokenServer) {
            this.web3AccessTokenServer = options.web3AccessTokenServer;
        }
        log.debug(`web3AccessTokenServer: ${this.web3AccessTokenServer}`);
    }
    checkConnectionRequirements() {
        // we reconnect without killing existing wallet connect session on calling connect again.
        if (this.name === SUPPORTED_ADAPTERS.WALLET_CONNECT_V2 &&
            this.status === ADAPTER_STATUS.CONNECTING)
            return;
        else if (this.status === ADAPTER_STATUS.CONNECTING)
            throw Error("Already connecting");
        if (this.status === ADAPTER_STATUS.CONNECTED)
            throw Error("Already connected");
        if (this.status !== ADAPTER_STATUS.READY)
            throw Error("Wallet adapter is not ready yet, Please wait for init function to resolve before calling connect/connectTo function");
    }
    checkInitializationRequirements() {
        if (!this.currentChainConfigId)
            throw Error("rpcTarget is required in chainConfig");
        if (this.status === ADAPTER_STATUS.NOT_READY)
            return;
        if (this.status === ADAPTER_STATUS.CONNECTED)
            throw Error("Already connected");
        if (this.status === ADAPTER_STATUS.READY)
            throw Error("Adapter is already initialized");
    }
    checkDisconnectionRequirements() {
        if (this.status !== ADAPTER_STATUS.CONNECTED)
            throw Error("Not connected with wallet");
    }
    checkSwitchChainRequirements(chainId) {
        if (!this.knownChainConfigs[chainId])
            throw Error("Unknown chainId");
        if (!this.provider && this.status !== ADAPTER_STATUS.CONNECTING)
            throw Error("Not connected with wallet.");
    }
    initChainConfig() {
        defaultChainConfigs.forEach((chainConfig) => {
            this.knownChainConfigs[chainConfig.chainId] = chainConfig;
        });
    }
    getChainConfig(chainId) {
        return this.knownChainConfigs[chainId] || null;
    }
}
//# sourceMappingURL=IAdapter.js.map